// Precisa vir antes de qualquer módulo que resolva tradução no topo (routes.tsx usa t()).
import './lib/i18n';
import './lib/zod-error-map';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import './global.css';
import '@context/prototypes';
import 'api/axios-instance';

import { MaterialUIControllerProvider } from 'context';
import { AuthProvider } from 'context/auth-context';
const root = createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <MaterialUIControllerProvider>
            <AuthProvider>
                <App />
            </AuthProvider>
        </MaterialUIControllerProvider>
    </BrowserRouter>
);
